import moment from "moment";
import { stringify, parse } from "query-string";
import { AdvancedFilters } from "./types";
import { formatDate } from "../../helpers";
import {
  CourtSurface
} from "../WhatsOnTable/types";

export interface refreshURLProps {
  date: moment.Moment | null;
  showFullYear: boolean;
  results: boolean;
  filters: AdvancedFilters;
  circuitCode?: string;
  location?: any;
}

export const parseString = (filter: CourtSurface[]) => {
  const active = filter.filter(f => f.active);
  return filter.reduce(
    (accumulator: string, currentValue: CourtSurface) => {
      if (currentValue.active) {
        return `${accumulator}${currentValue.code}${active.length > 1 ? "," : ""}`;
      } else {
        return accumulator;
      }
    },
    ""
  )
};

export const refreshURLState = ({
  date = moment(),
  showFullYear,
  results = false,
  filters,
  circuitCode,
  location = window.location
}: refreshURLProps) => {
  const search = Object.keys(parse(location.search)).reduce(
    (obj: any, key: string) => {
      obj[key.toLowerCase()] = parse(location.search)[key];
      return obj;
    },
    {}
  );

  const startdate: any = !showFullYear
    ? results ? formatDate(date).raw : formatDate(date).rawYearMonth
    : formatDate(date).rawYear;

  const checkFilters = [
    { name: "matchTypes", param: "matchtype" },
    { name: "grandSlams", param: "grandslams" },
    { name: "ageCategories", param: "agecategories" },
    { name: "courtSurfaces", param: "courtsurfaces" },
    { name: "courtDoorness", param: "courtdoorness" },
    { name: "categories", param: "categories" },
    { name: "playerTypes", param: "playertype" },
    { name: "tennisCategories", param: "tenniscategories" }
  ];

  let categories = filters.categories.map(cat => ({
    name: cat.label,
    code: cat.value,
    active: cat.selected
  }))

  let _filters = {
    ...filters,
    categories
  }

  checkFilters.forEach(({ name, param }: { name: string; param: string }) => {
    const courtFlag = name === "courtSurfaces" || name === "courtDoorness";
    const selected = filters[name].filter((filter: any) => courtFlag ? filter.active : filter.selected);
    const flag = selected.length && (courtFlag ? filters[name].some((filter: any) => !filter.active) : selected[0].value);
    if (flag && filters[name].length > 1) {
      search[param] = courtFlag || name === "categories" ? parseString(_filters[name]) : selected[0].value
    } else {
      delete search[param];
    }
  })

  if (!circuitCode) {
    delete search.circuitcode;
  } else {
    search.circuitcode = circuitCode;
  }

  const link = `${location.pathname}?${stringify({
    ...search,
    startdate
  })}`;

  history.replaceState("", "", link);

  return link;
};